// built-from: /canonical-domain-scenarios v1 impl:canonical-domain-scenarios role:implementation
export const captureCommercialVision = Object.freeze({
  id: 'capture-commercial-vision',
  name: 'Agree the commercial vision',
  method: 'North Star facilitation',
  purpose: 'Agree the direction, outcomes, measures, constraints and assumptions that guide discovery.',
});

export const analyseEngagementDocuments = Object.freeze({
  id: 'analyse-engagement-documents',
  name: 'Analyse supplied engagement documents',
  method: 'Document synthesis',
  purpose: 'Extract evidence, contradictions, uncertainties and candidate exploratory work.',
});

export const mapCurrentValueStreams = Object.freeze({
  id: 'map-current-value-streams',
  name: 'Map priority value streams',
  method: 'Voice-led value-stream mapping',
  purpose: 'Understand how customer value and work currently flow across teams and systems.',
});

export const mapBusinessDomains = Object.freeze({
  id: 'map-business-domains',
  name: 'Map business domains',
  method: 'Facilitated domain discovery',
  purpose: 'Capture how business participants understand responsibilities and boundaries.',
});

export const analyseTechnicalEstate = Object.freeze({
  id: 'analyse-technical-estate',
  name: 'Analyse the technical estate',
  method: 'Static code, integration and data analysis',
  purpose: 'Test document-derived concerns about ownership, dependencies and migration constraints.',
});

export const mapSystemDomains = Object.freeze({
  id: 'map-system-domains',
  name: 'Map system domains',
  method: 'Event Storming with technical evidence',
  purpose: 'Understand system boundaries from the events that flow through the platform.',
});

export const commercialVision = Object.freeze({
  id: 'commercial-vision',
  name: 'Agreed commercial vision',
});

export const documentEvidenceSet = Object.freeze({
  id: 'document-evidence-set',
  name: 'Document evidence set',
});

export const currentValueStreamModel = Object.freeze({
  id: 'current-value-stream-model',
  name: 'Reviewed current value-stream model',
});

export const businessDomainModel = Object.freeze({
  id: 'business-domain-model',
  name: 'Business domain model',
});

export const technicalEstateInventory = Object.freeze({
  id: 'technical-estate-inventory',
  name: 'Technical estate inventory',
});

export type ActivityState = 'proposed' | 'planned' | 'in-progress' | 'awaiting-review' | 'complete';

export type ActivityDefinition = {
  readonly id: string;
  readonly name: string;
  readonly method: string;
  readonly purpose: string;
};

export type ActivityInstance = {
  id: string;
  definition: ActivityDefinition;
  owner: { id: string; name: string; role: string };
  participants: ReadonlyArray<{ id: string; name: string; role: string }>;
  output: { id: string; name: string };
  state: ActivityState;
  progress: string;
  source?: string;
  question?: string;
  whyNow?: string;
  linkedOutcome?: { id: string; name: string };
  linkedMeasure?: { id: string; name: string };
  inputs?: ReadonlyArray<string>;
  completionCriteria?: ReadonlyArray<string>;
  reviewer?: { id: string; name: string; role: string };
};

export function buildActivity<T extends ActivityInstance>(
  canonical: T,
  overrides: Partial<T> = {},
): T {
  return Object.freeze({ ...canonical, ...overrides });
}
